(() => {
  const init = () => {
    document.querySelectorAll('[data-wet-carousel]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const rail = root.querySelector('.wet-grid');
      const previous = root.querySelector('[data-wet-prev]');
      const next = root.querySelector('[data-wet-next]');
      const toggle = root.querySelector('[data-wet-grid]');
      const update = () => { previous.disabled = rail.scrollLeft < 2; next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2; };
      root.querySelector('.wet-carousel-controls').hidden = false;
      root.classList.add('wet-carousel');
      const move = direction => rail.querySelector('article') && rail.scrollBy({left: direction * (rail.querySelector('article').getBoundingClientRect().width + 18), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      toggle.addEventListener('click', () => { const grid = root.classList.toggle('wet-carousel--grid'); toggle.setAttribute('aria-pressed', String(grid)); previous.hidden = next.hidden = grid; update(); });
      rail.addEventListener('scroll', update, {passive:true}); new ResizeObserver(update).observe(rail); update();
    });
    document.querySelectorAll('.wet-categories a').forEach(link => { if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current','page'); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
